import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import _ from "lodash";
import PageLoader from "../../../../../../components/PageLoader";
import {orderData} from '../settlement-items'

import { SettlementItemPopup } from "../components/settlement-item-popup.component";
import { updateNestedValue } from "../../../../../../common/services/common.service";
import { settlementItems } from "../../../../../../redux/settlement-hub/settlement-items/action";
import { selectSettlementItemCreatedItem, selectSettlementItemDeletedItem, selectSettlementItemsListItems, selectSettlementItemUpdatedItem } from "../../../../../../redux/settlement-hub/settlement-items/selector";
import { libraryData, BUYER_APP, TO_BE_INITIATED } from "../../constants/constants";

const SettlementItems = ({
  selectedSettlementRequest
}: any) => {

  const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [showSettlementItemPopup, setShowSettlementItemPopup] = useState<boolean>(false);
  const [selectedSettlementItem, setSelectedSettlementItem] = useState<any>({
    "Id": 0,
    "SettlementId": 0,
    "SettlementItemStatusId": TO_BE_INITIATED,
    "OrderId": "0",
    "ParticipantId": "0",
    "ParticipantRoleId": BUYER_APP,
    "ReferenceNo": "0",
    "SettlementFor": "",
    "SettledAmount": {
      "currency": "INR",
      "value": "0"
    },
    "Amount": {
      "currency": "INR",
      "value": "0"
    }
  });
  const [listItems, setListItems] = useState<any>([]);
  const listOfSettlementItemsData = useSelector(selectSettlementItemsListItems)
  const createSettlementItemsData = useSelector(selectSettlementItemCreatedItem)
  const editSettlementItemsData = useSelector(selectSettlementItemUpdatedItem)
  const deleteSettlementsItemData = useSelector(selectSettlementItemDeletedItem)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'OrderId', headerName: 'Order Id', sortable: true, filter: true, filterType: 'text',  },
      { field: 'ParticipantId', headerName: 'Participant', sortable: true, filter: true, filterType: 'text',  },
      { field: 'ReferenceNo', headerName: 'Reference No', sortable: true, filter: true, filterType: 'text',  },
      { field: 'SettlementFor', headerName: 'Settlement For', sortable: true, filter: true, filterType: 'text',  },
      { field: 'SettledAmount.value', headerName: 'Settled Amount', sortable: true, filter: true, filterType: 'number',  },
      { field: 'Amount.value', headerName: 'Amount', sortable: true, filter: true, filterType: 'number',  },
      { field: 'SettlementItemStatusId', headerName: 'Status', sortable: true, filter: true, filterType: 'text', cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData, menuKey: 'Value', menuValue: 'Description', callback: handleStatus, anchorPosition: 'top-left' },
},
      {field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
      {field: 'UpdatedOnUtc', headerName: 'Updated On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
    ]);
  }

  const handleStatus = () => {

  }

  const handleInnerFormChange: any = ({path, value}: any) => {
    console.log('selectedSettlementItem, path, value', selectedSettlementItem, path, value)
    const updatedData = updateNestedValue(selectedSettlementItem, path, value)

    console.log('updatedData', updatedData)
    setSelectedSettlementItem({...updatedData});
  }

  const handleAdd = () => {   
    const participant = {
      "Id": 0,
      "SettlementId": 0,
      "SettlementItemStatusId": TO_BE_INITIATED,
      "OrderId": "0",
      "ParticipantId": "0",
      "ParticipantRoleId": BUYER_APP,
      "ReferenceNo": "0",
      "SettlementFor": "",
      "SettledAmount": {
        "currency": "INR",
        "value": "0"
      },
      "Amount": {
        "currency": "INR",
        "value": "0"
      }
    }
    setSelectedSettlementItem({...participant})
    setShowSettlementItemPopup(true)
  }

  const handleEdit = (data: any) => {
    setSelectedSettlementItem(data)
    setShowSettlementItemPopup(true)
  }

  const handleDelete = async (data: any) => {
    console.log('delete item', data)
    // const ids = _.map(data, (item: any) => {return {Id: item?.SettlementRequest?.Id}})
    // console.log('ids',ids)
    await dispatch(settlementItems.delete({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlement-items/delete`,
      entity: 'settlementItems',
      jsonData: {
        Context:{},
        Records: [{Id: data?.SettlementRequest?.Id}]
      }
    }));
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Settlement Item</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Initiate Settlement',
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];


  const handleReloadData = () => {
    listSettlementRequestItems();
  }


  const listSettlementRequestItems = async () => {
    console.log('settlementItems')
    await dispatch(settlementItems.resetAction({actionType:'list'}))
    await dispatch(settlementItems.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlement-items/list`,
      entity: 'settlementItems',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleSaveSettlementItem = async (selectedSettlementItem: any) => {
    console.log('selectedSettlementItem', selectedSettlementItem)
    
    setSelectedSettlementItem(selectedSettlementItem)
    console.log('selectedSettlementItem', selectedSettlementItem)
    if (selectedSettlementItem?.Id > 0) {      
      await dispatch(settlementItems.resetAction({actionType:'update'}))
      await dispatch(settlementItems.update({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlement-items`, entity: 'productSpecificationAttributeOptions', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedSettlementItem
              }]
            }
          ]
        }
      }))
    } else {
      await dispatch(settlementItems.resetAction({actionType:'update'}))
      await dispatch(settlementItems.create({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/settlement-items`, entity: 'productSpecificationAttributeOptions', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedSettlementItem
              }]
            }
          ]
        }
      }))
    }
    closeModal();
    listSettlementRequestItems();
  }

  const closeModal = () => {
    setShowSettlementItemPopup(false)
  }

  useEffect(() => {
    console.log('listOfSettlementItemsData', listOfSettlementItemsData)
    // if(listOfSettlementItemsData?.isSuccess){
      if(listOfSettlementItemsData?.result?.items && listOfSettlementItemsData?.result?.items?.length > 0)
      {
        console.log('listOfSettlementItemsData?.result?.items[0].Error', listOfSettlementItemsData?.result?.items[0].Error)
        if (listOfSettlementItemsData?.result?.items[0].Error){
          setListItems(orderData)          
        }   
        else {
          setListItems(listOfSettlementItemsData?.result?.items)
        }     
      }  else {
        console.log('orderData', orderData)
        setListItems(orderData)
      }    
    // }
  }, [listOfSettlementItemsData]);

  // useEffect(() => {
  //   setListItems(orderData)
  // }, []);

  useEffect(() => {
    console.log('list items', listItems)
  
  }, [listItems]);

  useEffect(() => {
    listSettlementRequestItems();
  }, [deleteSettlementsItemData]);

  useEffect(() => {
    createColumnDefs()
    listSettlementRequestItems()
  }, [pageData, pageSize])

  return (
    <>
      {
        showSettlementItemPopup ?
          <SettlementItemPopup
            // selectedParticipant={selectedParticipant}
            selectedSettlementItem={selectedSettlementItem}
            closeModal={closeModal}
            handleSaveSettlementItem={handleSaveSettlementItem}
            handleInnerFormChange={handleInnerFormChange}
          /> : <></>
      }

      {listOfSettlementItemsData?.isLoading || 
      createSettlementItemsData?.isLoading || 
      editSettlementItemsData?.isLoading || 
      deleteSettlementsItemData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          enableFilter={true}
          rowData={listItems}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={listOfSettlementItemsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          headingName="Settlement Items" />
      }
    </>
  );
};

export default SettlementItems;


